// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"divider-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 12H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 19H6M10.5 19H13.4966M18 19H21M3 5H6M10.5 5H13.4966M18 5H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Divider1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'divider-1',
    ref,
    icon: element,
  },
));

Divider1Icon.displayName = 'Divider1Icon';

export default Divider1Icon;
